import { all, call, put, select } from 'redux-saga/effects';
import * as settingsService from '../../resource/settings/settings.saga-service';
import * as wrikeFolderMeetingService from '../../resource/wrike-folder-meeting/wrike-folder-meeting.saga-service';
import * as annualsService from '../../resource/annuals/annuals.saga-service';
import { ISettingsUpdate } from '../../resource/settings/settings.types';
import * as pageStateService from '../page-state/page-state.saga-services';
import * as pageInitializerService from '../page.initializer.saga-service';
import * as actions from './settings.actions';
import { settingsPageSelectors } from './settings.selectors';
import * as boardListService from '../../resource/boards/boardList/boardList.saga-service';

export function* initialSettingsPage() {
  const isFetched = (yield select(settingsPageSelectors.selectIsFetched)) as boolean;
  if (!isFetched) {
    yield call(pageStateService.initPage, 'settings');

    const results = (yield all([
      call(pageInitializerService.initPage),
      call(annualsService.getAnnuals),
      call(boardListService.fetchTaskTypesByBoard),
    ])) as [boolean, void, void];
    const isExpiredToken = results[0];

    if (!isExpiredToken) {
      yield call(settingsService.searchSettings);
    }

    yield put(actions.storeIsFetched());
    yield call(pageStateService.completedInit, 'settings');
  }
}

export function* setupSettings() {
  yield call(settingsService.searchSettings);
}

export function* updateSettings(settings: ISettingsUpdate) {
  yield call(settingsService.updateSettings, settings);
}

export function* resetPrimaryColors() {
  yield call(settingsService.resetPrimaryColors);
}

export function* resetSecondaryColors() {
  yield call(settingsService.resetSecondaryColors);
}

export function* clearSettingsPageStorage() {
  yield put(actions.clearIsFetched());
}

export function* fetchWrikeFolderMeetings() {
  const response = yield call(wrikeFolderMeetingService.fetchWrikeFolderMeetings);
  return response;
}
